import gCard from "@/components/g-card/g-card";
import gForm from "@/components/g-form/g-form.vue";

const name = 'PDFPedidoFinal'
export default {
  name,

  components: {
    'g-card': gCard,
    'g-form': gForm,
   },

  props: { },

  mounted () {
    var pediId =  this.$route.params.id
    this.PedidoId = pediId
    this.PopulaResumoFinal()
  },

  updated () { 
    var pediId =  this.$route.params.id
    this.PedidoId = pediId
    this.PopulaResumoFinal()
  },

  data () {
    return {
      PedidoArray:[],
      PedidoFreteArray:[],
      renderiza: false,
      executarvisualizacao: 0,
      PedidoId: null,
      quantidadeParcelaArray: []
    }
  },

  methods: {
    PopulaResumoFinal(){
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetResumoFinalPedido/${this.PedidoId}`,
      })
      .then((response) =>{
        this.PedidoArray = response.data.data;
        this.PopulaResumoFinalFrete()
      })
      .finally(()=> {
        this.$isLoading(false)
      })
    },

    novoPedido () {
      this.$router.push('/gerar-novo-pedido-inicio')
    },

    PopulaResumoFinalFrete() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetResumoFinalPedidoFrete/${this.PedidoId}`,
      })
      .then((response) =>{
        this.PedidoFreteArray = response.data.data;
        this.GetQuantidadeParcela();
      })
      .catch(() => {
      });
    },

    consultarpedidos() {
      this.$router.push('/gerar-novo-pedido-inicio')
    },

    executaTermino() { 
      this.$emit('termino')
    },

    GetQuantidadeParcela(){
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetQuantidadeParcela/${this.PedidoId}`,
      })
      .then((response) =>{
        this.quantidadeParcelaArray = response.data.data;
        this.executaTermino();
      })
      .finally(()=> {
        this.$isLoading(false)
      })
    },
  },

  computed: { },

};